/**
 * GTM（dataLayer）への送出。
 *
 * gtag と同じく**外部 SDK は読み込まない**。違いは push 先だけだが、
 * 「まだ dataLayer が無ければ配列を作る」点が異なる — GTM はあとから読み込まれたときに
 * 既存の配列を消化する標準の挙動を持つので、先に積んでおけば取りこぼさない。
 * 配列を勝手に作るのは**導入者が明示的に有効化したときだけ**なので、副作用は意図の範囲内。
 */
import type { AnalyticsAdapter, AnalyticsContext, AnalyticsEvent } from '../types';
import { GA4_NAMES, ga4Params } from './ga4-names';

export class DataLayerAdapter implements AnalyticsAdapter {
  constructor(private readonly view: Window) {}

  send(events: readonly AnalyticsEvent[], context: AnalyticsContext): void {
    const target = this.view as unknown as { dataLayer?: unknown[] };
    try {
      const layer = Array.isArray(target.dataLayer)
        ? target.dataLayer
        : (target.dataLayer = []);
      for (const event of events) {
        layer.push({
          event: GA4_NAMES[event.event],
          ...ga4Params(context.book, event.sid, event.page, event.value),
        });
      }
    } catch {
      /* ホスト側の都合で失敗しても閲覧に影響させない */
    }
  }
}
